<template>
  <b-card>
    <b-row>
      <b-col class="col-md-12">
        <h2 class="text-blue font-weight-bold mt-1">
          {{ $t("invoices") }}
        </h2>
      </b-col>
    </b-row>
    <Table
        :body="{}"
        :updateData="makeCall"
        :url="url"
        :fields="fields"
        :showSearch="false"
        @updateProp="updateProp"
    >
      <template #cell(id)="data">
        <router-link :to="'/invoice/'+data.item.id" style="width:55px;" class="badge badge-light-primary">
          I-{{ data.item.id }}
        </router-link>
      </template>
      <template #cell(debtor)="data">
        <span v-html="data.item.debtor ? data.item.debtor.name : '-'"></span>
      </template>
      <template #cell(currency)="data">
          <span v-html="data.item.currency ? data.item.currency.code : '-'">
          </span>
      </template>
      <template #cell(amount)="data">
          <span v-if="data.item.amount">
            {{ data.item.amount | formatAmount }}
          </span>
        <span v-else>-</span>
      </template>
      <template #cell(invoice_number)="data">
          <span
              v-html="data.item.invoice_number ? data.item.invoice_number : '-'"
          >
          </span>
      </template>
      <template #cell(status)="data">
        <span :class="getStatus(data).class">
          {{ $t(getStatus(data).label) }}
        </span>
      </template>
      <template #cell(custom)="data">
        <b-button
            v-b-tooltip.hover :title="$t('read_pdf')"
            class="mt-1 web"
            @click="readPdf(data.item.id, data.item)"
            variant="outline-success"
            size="sm"
        >
          <FeatherIcon icon="BookOpenIcon"></FeatherIcon>
        </b-button>
      </template>
      <template #cell(silent)="data">
        <span v-if="data.value == 0">- </span>
        <span v-if="data.value == 1">{{ $t("yes") }}</span>
      </template>
      <template #cell(recourse)="data">
        <span v-if="data.value == 0">- </span>
        <span v-if="data.value == 1">{{ $t("yes") }}</span>
      </template>
      <template #cell(flash_sale)="data">
        <span v-if="data.value == 0">- </span>
        <span v-if="data.value == 1">{{ $t("yes") }}</span>
      </template>
    </Table>
  </b-card>
</template>
<script>
import Table from "@/components/Common/Table2.vue";
import fileDownload from "js-file-download";
import { BButton } from 'bootstrap-vue'

export default {
  components: { BButton, Table },
  data() {
    return {
      fields: [
        { label: "reference", align: "start", key: "id", sortable: true },
        { label: "debtor", align: "start", key: "debtor", sortable: false },
        { label: "invoice_number", align: "start", key: "invoice_number", sortable: false,},
        { label: "currency", align: "start", key: "currency", sortable: false },
        { label: "invoice_amount", align: "start", key: "amount", sortable: false,},
        { label: "silent", align: "start", key: "silent", sortable: false },
        { label: "recourse", align: "start", key: "recourse", sortable: false,},
        { label: "flash_sale", align: "start", key: "flash_sale", sortable: false,},
        { label: "status", key: "status", customSlot: true, sortable: false },
        { label: "title", align: "end", key: "custom", customSlot: true, sortable: false,},
      ],
      url: "",
      invoice: null,
      item: null,
      showPdfViwer: false,
      type: "",
      base64: "",
      source: null,
      src: "",
      embedType: "",
    };
  },
  props: ["makeCall"],

  created() {
    this.url = `/invoice/admin/${this.$route.params.id}/list`;
  },
  methods: {
    readPdf(id, item) {
      this.item = item;
      this.$store.commit("app/ON_SIDEBAR_CLICK", false);
      this.loadPdf = true;
      this.type = "";
      this.base64 = "";
      this.src = "";
      this.embedType = "";

      this.$http
        .post("/invoice/admin/read/" + id, {
          responseType: "json",
        })
        .then((response) => {
          this.base64 = response.data.value.b64;
          this.type = response.data.value.ext;
          if (this.type === "pdf") {
            this.showPdfViwer = false;
            this.src =
              "data:application/" +
              this.type +
              ";base64," +
              this.base64 +
              "#toolbar=0";
            this.embedType = "application/" + this.type;

            this.loadPdf = false;
            this.showPdfViwer = true;
          } else {
            this.showPdfViwer = false;
            this.src =
              "data:image/" +
              this.type +
              ";base64," +
              this.base64 +
              "#toolbar=0";
            this.embedType = "image/" + this.type;

            this.loadPdf = false;
            this.showPdfViwer = true;
          }

          this.$store.commit("app/SET_FILE_TYPE", this.type);
          this.$store.commit("app/SET_FILE_BASE64", this.base64);

          window.open("/read-files", "_blank");
        });
    },
    downloadPdf(id) {
      this.isLoading = true;
      this.$http
        .post(
          "/invoice/admin/download/" + id,
          {},
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          fileDownload(response.data, "doc.pdf");
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    updateProp() {},
    getStatus({ value, item }) {

      const map = {
        0: { class: "text-secondary", label: "Open" },
        1: { class: "text-success", label: "active_marketplace_offer" },
        2: { class: "text-danger", label: "rejected" },
        3: { class: "text-secondary", label: "scoring_required" },
        4: { class: "text-secondary", label: "scored" },
        5: { class: "text-secondary", label: "click_sell_invoice" },
        6: (item) =>
            item?.recourse === 0
                ? {
                  class: "text-secondary",
                  label:
                      item?.is_reverse === 1
                          ? "supplier_confirmation_required"
                          : "debtor_confirmation_required",
                }
                : { class: "text-secondary", label: "-" },
        7: { class: "text-secondary", label: "rejected" },
        8: { class: "text-secondary", label: "soon_goes_active" },
        9: { class: "text-secondary", label: "in_review" },
        10: { class: "text-secondary", label: "sold" },
        11: { class: "text-secondary", label: "settled" },
        12: { class: "text-secondary", label: "send_offer" },
        13: { class: "text-secondary", label: "invoice_default" },
        14: { class: "text-danger", label: "deactivated" },
        15: { class: "text-danger", label: "removed_from_marketplace" },
        16: { class: "text-secondary", label: "required_seller_confirmation" },
      };

      const entry = map[value];

      if (!entry) return { class: "text-muted", label: "unknown" };

      return typeof entry === "function" ? entry(item) : entry;
    },

  },
};
</script>
